import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@data-delivery/d3s';
import type { Control } from 'react-hook-form';
import type { UserFormValues } from '../schemas/user-form.schema';

interface UserFoldersSectionProps {
  control: Control<UserFormValues>;
  canEditLandingFolder?: boolean;
}

export function UserFoldersSection({ control, canEditLandingFolder }: UserFoldersSectionProps) {
  return (
    <div className='rounded-md border p-4 text-sm'>
      <p className='font-medium mb-2'>Access & Folder Structure</p>
      <p className='text-muted-foreground mb-4'>
        Define root and optional landing folders. Naming rules and restrictions are validated live.
      </p>
      <div className='grid grid-cols-12 gap-4'>
        <div className='col-span-12 md:col-span-4'>
          <FormField
            control={control}
            name='rootFolder'
            render={({ field }) => (
              <FormItem className='flex flex-col gap-1'>
                <FormLabel>Root Folder *</FormLabel>
                <FormControl>
                  <Input {...field} placeholder='/root' />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className='col-span-12 md:col-span-4'>
          <FormField
            control={control}
            name='landingFolder'
            render={({ field }) => (
              <FormItem className='flex flex-col gap-1'>
                <FormLabel>Landing Folder</FormLabel>
                <FormControl>
                  <Input {...field} placeholder='/landing' disabled={!canEditLandingFolder} />
                </FormControl>
                {!canEditLandingFolder && (
                  <p className='text-xs text-muted-foreground'>
                    Landing folder can only be changed by operators.
                  </p>
                )}
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className='col-span-12 md:col-span-4'>
          <FormField
            control={control}
            name='sfAccountId'
            render={({ field }) => (
              <FormItem className='flex flex-col gap-1'>
                <FormLabel>SF Account ID</FormLabel>
                <FormControl>
                  <Input {...field} placeholder='sf-123' />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
}
